/**
 * UI控件库 
 * @module UI
 */
;(function (ui,$) {
  "use strict";

    /**
     * <h3>下拉选择菜单</h3>
     * <a href="../../ui_controls/bui.select.html" target="_blank">demo</a>
     * <p>支持单选,多选,跟普通点击触发</p>
     * <h5>方法</h5>
     * {{#crossLink "bui.select/option"}}{{/crossLink}}: 获取设置参数 <br>
     * {{#crossLink "bui.select/widget"}}{{/crossLink}}: 获取依赖控件 <br>
     * {{#crossLink "bui.select/value"}}{{/crossLink}}: 设置值 <br>
     * {{#crossLink "bui.select/text"}}{{/crossLink}}: 设置文本 <br>
     * {{#crossLink "bui.select/show"}}{{/crossLink}}: 显示 <br>
     * {{#crossLink "bui.select/hide"}}{{/crossLink}}: 隐藏 <br>
     * {{#crossLink "bui.select/selectAll"}}{{/crossLink}}: 全选 <br>
     * {{#crossLink "bui.select/selectNone"}}{{/crossLink}}: 全不选 <br>
     *  @namespace bui
     *  @class select
     *  @constructor 
     *  @param {object} option  
     *  @param {string} [option.id] [ select 控件id 静态绑定的ID]  
     *  @param {array} [option.data] [二级菜单的数据,静态绑定无需传数据]  
     *  @param {string} [option.data.name] [显示的文本]  
     *  @param {string} [option.data.value] [文本的值,相当于option的value] 
     *  @param {string} [option.trigger] [触发select框的按钮,需要为ID]  
     *  @param {string} [option.triggerChildren] [选中后值的位置]  
     *  @param {string} [option.className] [自定义checkbox的值]   
     *  @param {string} [option.title] [弹出层的标题]   
     *  @param {boolean} [option.popup] [ 是否弹出, 为true 下面效果才会有效 ]  
     *  @param {boolean} [option.height] [ 默认0]  
     *  @param {boolean} [option.width] [ 默认0]  
     *  @param {boolean} [option.autoClose] [ 默认false | true 点击以后自动关闭 checkbox 需要手动隐藏]  
     *  @param {boolean} [option.mask] [ true | false 是否显示遮罩]  
     *  @param {boolean} [option.fullscreen] [ false | true 是否全屏]  
     *  @param {string} [option.effect] [出现的效果,更多参考{{#crossLink "bui.toggle"}}{{/crossLink}}]  
     *  @param {string} [option.type] [ 选择的类型 radio | checkbox | select ]  
     *  @param {string} [option.direction] [ type出现的位置 left | right | center]  
     *  @param {string} [option.position] [ 显示的位置 top | bottom | center  ]  
     *  @param {function} [option.onChange] [ 点击checkbox | radio 的回调 ]  
     *  @param {function} [option.callback] [ 点击确定按钮的回调 ]  
     *  @example
     * 
     *   html:
     *
            <div id="select" class="bui-select">请选择</div>
     *      
     *   js: 
     *   
            // 动态绑定初始化
            var uiSelect = bui.select({
                trigger: "#select",
                type:"checkbox",
                data: [{
                    "name":"广东",
                    "value":"11"
                },{"name":"广西",
                    "value":"22"
                },{
                    "name":"上海",
                    "value":"33"
                },{"name":"北京",
                    "value":"44"
                },{
                    "name":"深圳",
                    "value":"55"
                },{"name":"南京",
                    "value":"66"
                }]
            })
     *
     *
     */
    ui.select = function(option){
        
        //默认配置
        var config = {
            id: "",     //静态绑定        
            trigger: "",  
            triggerChildren: ".span1",  
            className: "",
            data: [],           
            popup: true,
            title: "",
            autoClose: false,        
            height: 0,        
            width: 0,        
            mask: true,
            change: true,
            effect: "fadeInUp",
            type: "radio", //radio | checkbox | select
            direction: "right", 
            position: "bottom",
            fullscreen: false,
            buttons: [],// {name: "确定",className: "primary"}
            onChange: null,
            callback: null
        }
        
        //方法
        var module = {
            value: value,
            text: text,
            show: show,
            hide: hide,
            selectAll: selectAll,
            selectNone: selectNone,
            unselect: unselect,
            widget: widget,
            option: options,
            config: param,
            init: init
        };
        //用于option方法的设置参数
        var param = module.config = $.extend(false,{}, config, ui.config.select, option );

        
        var $trigger,
            $id,
            //对话框的id
            gid,
            initText,
            $children,
            uiMask,
            selects = [], 
            selectText,
            selectValue,
            uiDialog;
        
        //执行初始化
        init(param);

        //初始化
        function init (option) {
            option = option || param;
            
            selectText = [];
            selectValue = [];
            //对话框的id
            gid = option.id ? option.id: ui.guid();

            //option获取新参数使用
            param = module.config = option;
            
            //是否是弹出
            if( option.popup ){

                //动态数据
                if( option.data.length ){
                    //生成结构
                    var html = template( option.data );
                    $('body').append(html);
                }

                uiDialog = ui.dialog({
                    id: gid,
                    effect: option.effect,
                    mask: option.mask,
                    position: option.position,
                    autoClose: false,
                    height: option.height,
                    width: option.width,
                    zoom : false,
                    fullscreen: option.fullscreen,
                    onMask: function (argument) {
                        hide();
                    }
                });
                $id = ui.obj( gid );

            }else{

                if( !option.id ) {
                    ui.hint("select id 必须有");
                    return;
                }
                $id = ui.obj( option.id );


                //动态数据
                if( option.data.length ){
                    //生成结构
                    var html = template( option.data );

                    $id.append(html);
                }
            }


            if( option.trigger ){

                $trigger = ui.obj(option.trigger) ;

                //是否里面有布局的情况
                $children = $trigger.find( option.triggerChildren ).length ?  $trigger.find( option.triggerChildren ):  $trigger;
                //初始化select的值
                initText = option.title || $.trim( $children.html() );
                //把title设置进去,这样才能点击到
                if( option.title ){

                    $children.html( option.title );
                }
                //绑定按钮触发
                $trigger.off("click.bui").on("click.bui",function (argument) {

                    // var status = $id.attr("status") || 0;
                    // if( status == "0" ){
                       // 显示
                        show();
                    // }
                })

            }

            //绑定二级菜单点击,事件绑在input避免触发两次,因为label已经触发到input
            $id.off("change","input").on("change","input",function (e) {

                var val = $(this).val(),
                    index = $(this).parent().index(); 
                    name = $(this).attr("text") || $(this).parent().text();

                var isChecked = $(this).is(':checked');

                switch( option.type ){
                    //单选框处理
                    case "radio":
                    selectText = [];
                    selectValue = [];

                    selectText.push(name);
                    selectValue.push(val);

                    value( val || "");
                    text( name || initText || "" );
                    
                    break;
                    //单选处理
                    case "select":

                    selectText = [];
                    selectValue = [];

                    selectText.push(name);
                    selectValue.push(val);

                    value( val || "");
                    text( name || initText || "" );

                    break;
                    //多选处理
                    case "checkbox":

                        var prevValue = $id.attr("value");
                        var prevText = $id.attr("text");

                        if( prevValue && prevValue.indexOf(",") > -1 ){
                            selectValue = prevValue.split(",");
                            selectText = prevText.split(",");
                        }

                        //多选框处理
                        if( isChecked ){

                            selectText.push(name);
                            selectValue.push(val);
                        }else {
                            ui.removeArray(val,selectValue);
                            ui.removeArray(name,selectText);
                        }

                        value(selectValue.join(",") || "");
                        text( selectText.join(",") || "");

                    break;

                }

                //如果是要自动关闭,那点击li会触发关闭
                 if( option.popup && option.autoClose ){
                    hide();
                 }
              // 回调
                option.onChange && option.onChange.call(this,module,index);

                e.stopPropagation();
            })
            
            // 重置
            $id.off("click.bui", ".bui-dialog-foot .span1 .bui-btn").on("click.bui", ".bui-dialog-foot .span1 .bui-btn" ,function (e) {
                
                // 回调
                option.callback && option.callback.call(this,module);
                e.stopPropagation();
            });


            return this;
        }

        //生成模板
        function template (data) {
            
            var guid = ui.guid();

            var html = '';
            //生成弹窗
            if( param.popup ){
                html += '<div id="'+gid+'" class="bui-dialog bui-dialog-select">';

                    //多选框需要标题
                    if( param.title ){
                        html += '<div class="bui-dialog-head">'+param.title+'</div>';
                    }
                html +='  <div class="bui-dialog-main">';
            }

                html +='    <div class="bui-list">';
                    $(data).each(function (i,el) {

                        //选择框的类型
                        var checkbox = '';
                        if( param.type == "checkbox"){
                            checkbox ='        <input id="check-'+guid+'-'+i+'" type="checkbox" class="'+(param.className || "bui-checkbox")+'" name="'+guid+'" value="'+el.value+'" text="'+el.name+'">';

                        }else if(param.type == "radio") {
                            checkbox ='        <input id="check-'+guid+'-'+i+'" type="radio" class="'+(param.className || "bui-radio")+'" name="'+guid+'" value="'+el.value+'" text="'+el.name+'">';
                        }else if(param.type == "select") {
                            checkbox ='        <input id="check-'+guid+'-'+i+'" type="radio" class="'+(param.className || "bui-choose")+'" name="'+guid+'" value="'+el.value+'" text="'+el.name+'">';
                        }


                        //label标签下如果有input外标签,比方文本在div标签下,导致ios 下的label标签无法触发input
                        html +='    <div class="bui-btn bui-box bui-btn-line">';
                        //出现的位置
                        if( param.direction == "left"){
                            html += checkbox;
                        }
                        if (param.direction == "center"){

                            html +='        <div class="span1" align="center"><label for="check-'+guid+'-'+i+'" >'+el.name+'</label></div>';
                            html += checkbox;
                        }else{

                            html +='        <div class="span1"><label for="check-'+guid+'-'+i+'" >'+el.name+'</label></div>';
                        }
                        if( param.direction == "right"){
                            html += checkbox;
                        }
                        html +='    </div>';
                    })
                html +='    </div>';
            
            if( param.popup ){

                html +='  </div>';

                //手动控制隐藏
                if( param.buttons.length > 0 ){

                html +='    <div class="bui-dialog-foot bui-box-space">';
                $(param.buttons).each(function (i,item) {
                    html +='        <div class="span1">';
                    html +='             <div class="bui-btn round '+(item.className || '')+'" value="'+(item.value || '')+'">'+( item.name || item )+'</div>';
                    html +='        </div>';
                })
                html +='    </div>';
                }
                html +='</div>';
            }
                return html;
        }

        /**
         * 菜单显示
         *  @method show
         *  @chainable
         *  @example 
            
            //显示菜单
            uiSelect.show();
                
         */
        function show (callback) {
                
            if( param.popup && uiDialog ){
                //显示菜单
                !uiDialog.isOpen() && uiDialog.open(function() {
                    callback && callback.call(module);
                });


            }else{
                $id.css("display","block")//.attr("status","1"); 

                callback && callback.call(module);
            }

            return this;
        }

        /**
         * 菜单隐藏
         *  @method hide
         *  @chainable
         *  @example 
            
            //显示菜单
            uiSelect.hide();
                
         */
        function hide (callback) {

            if( param.popup && uiDialog ){

                //隐藏菜单
                uiDialog.isOpen() && uiDialog.close(function() {
                    callback && callback.call(module);
                });
                

            }else{
                $id.css("display","none")//.attr("status","0");
                
                callback && callback.call(module);

            }

            return this;

        }


        /**
         * 设置或者获取值, 会按二级菜单出现的顺序重新排序
         *  @method value
         *  @param {string} [text] [设置的值]
         *  @example 
            
            //设置值
            uiSelect.value("10");
                
         */
        function value (text) {

            //先清空原有的数据
            var data = [];
            selectText = [];
            selectValue = [];

            if( text || text == ''){
                //为了点击确定的时候,把值设置回去
                if( text.indexOf(",") > -1 ){
                    data = text.split(",");
                }else{
                    data.push(text);
                }

                //重新排序,并且弹出菜单的时候,要知道原来设置的值哪个是选中的
                $id.find(".bui-list").children().each(function (i,item) {
                    var $input = $(this).find('input');
                    var val = $input.val();
                    var text = $input.attr("text");

                    if( ui.compareArray( val, data) ){

                        //重新排序
                        selectText.push(text);
                        selectValue.push(val);

                        //更改为确定
                        $input.attr("checked","checked");
                    }
                })

                if( $trigger && param.change ){
                    //设置值
                    $trigger.attr("value",selectValue.join(","));
                }

                $id.attr("value",selectValue.join(","));

            }else{
                var value = $id.attr("value");
                return value;
            }
            
        }

        /**
         * 设置或者获取文本
         *  @method text
         *  @param {string} [text] [设置文本]
         *  @example 
            
            //设置文本
            uiSelect.text("广东省");
                
         */
        function text (value) {
            var val = val || "";

            if( value || value == '' ){
                if( $trigger && param.change ){
                    $trigger.attr("text",value);
                    $children.html( value || initText );
                }
                
                $id.attr("text",value);
            }else{
                var value = $id.attr("text");
                return value;
            }
            
        }

        /**
         * 全选,多选才能全选
         *  @method selectAll
         *  @example 
            
            //设置文本
            uiSelect.selectAll();
                
         */
        function selectAll() {

            //多选才有选择
            if( param.type != "radio" || param.type != "select"){
                 var selectText = [];
                var selectValue = [];

                //弹出菜单的时候,要知道原来设置的值哪个是选中的
                $id.find("input").each(function (i,item) {
                    var $input = $(this);
                    var val = $input.val();
                    var text = $input.attr("text");

                        //重新排序
                        selectText.push(text);
                        selectValue.push(val);

                        $input.prop("checked",true);
                });

                value(selectValue.join(",") || "");
                text( selectText.join(",") || "");
            }

            return this;
        }


        /**
         * 全不选
         *  @method selectNone
         *  @example 
            
            //设置文本
            uiSelect.selectNone();
                
         */
        function selectNone() {
            //重新排序
            var selectText = [];
            var selectValue= [];
            // if( param.type != "radio" || param.type != "select"){

                //弹出菜单的时候,要知道原来设置的值哪个是选中的
                $id.find("input").prop("checked",null);

                value("");
                text("");
            // }

            return this;
        }
        /**
         * 反选
         *  @method unselect
         *  @example 
            
            //设置文本
            uiSelect.unselect();
                
         */
        function unselect(argument) {
            
            if( param.type != "radio" || param.type != "select"){

                var selectText = [];
                var selectValue = [];

                //弹出菜单的时候,要知道原来设置的值哪个是选中的
                $id.find("input").each(function(i,item) {
                    var hasCheck = $(this).is(":checked"),
                        val = $(this).val(),
                        name = $(this).attr("text");

                    if( hasCheck ){
                        $(this).prop("checked",null);
                    }else{
                        $(this).prop("checked",true);

                        selectText.push(name);
                        selectValue.push(val);
                        
                    }
                })

                value(selectValue.join(",") || "");
                text( selectText.join(",") || "");

            }
        }

        /**
         * 获取依赖的控件
         *  @method widget
         *  @param {string} [name] [ 依赖控件名 dialog ]
         *  @example 
            
            //获取依赖控件
            var uiSelectWidget = uiSelect.widget();
            
                
         */
        function widget(name) {
            var control = uiDialog && { dialog: uiDialog};
                return ui.widget.call(control,name);
        };
        /**
         * 获取设置参数
         *  @method option
         *  @param { string | object } [key] [ 不传则获取所有参数, 类型为string,没有第2个参数则获取某个参数 ]
         *  @param { string | number | boolean | function } [value] [ 设置参数的时候要传,设置多个参数不用传,获取参数的时候也不用传 ]
         *  @chainable
         *  @example 
            
            
            //获取所有参数
             //获取所有参数
            var option = uiSelect.option();

            //获取某个参数
            var id = uiSelect.option( "id" );

            //修改一个参数
            uiSelect.option( "popup",false );

            //修改多个参数
            uiSelect.option( {"popup":false} );
                
         */
        function options (key,value) {

           return ui.option.call(module,key,value);
        }
        return module;

    };

    return ui;

})( bui || {}, libs );
